module.exports = __webpack_public_path__ + "static/img/img6.871e9cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/public/img6.png
// module id = /v32
// module chunks = 3